import Details from './details/ReleaseNotificationDetailsInitialState'

const { Record } = require('immutable')

export default Record({
    details: Details()
})